module.exports = function (data) {
    const event = {
        event: 'BWSAUviewCart',
        eventContext: {
            area: data.areaViewed
        }
    };

    if (data.trolleyProducts) {
        event.eventContext.products = [];

        for (let i = 0; i < data.trolleyProducts.length; i++) {

            const product = data.trolleyProducts[i];

            event.eventContext.products.push({
                quantity: product.Quantity,
                unitPrice: product.ListPrice,
                unitDisplay: product.Unit,
                productInfo: {
                    productName: product.ProductData.name,
                    brandName: product.ProductData.brandName,
                    productTitle: product.ProductData.title,
                    wasUnitPrice: product.ListPrice,
                    currentUnitPrice: product.SalePrice / product.Quantity,
                    isSpecial: product.IsSpecial,
                    webPackType: product.ProductData.webpacktype,
                    productUnitQuantity: product.ProductData.productunitquantity,
                    productSKU: product.Stockcode,
                    parentstockcode: product.ProductData.parentstockcode,
                    liquorSize: product.ProductData.liquorsize,
                    liquorStyle: product.ProductData.liquorstyle,
                    vintage: product.ProductData.vintage,
                    varietal: product.ProductData.varietal,
                    countryOfOrigin: product.ProductData.countryoforigin,
                    regionOfOrigin: product.ProductData.regionoforigin,
                    stateOfOrigion: product.ProductData.stateoforigin
                }
            });
        }
    }

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/atmmapper/open-cart-mapper.js
 **/